import script from "./take-photo.vue?vue&type=script&setup=true&lang=js"
export * from "./take-photo.vue?vue&type=script&setup=true&lang=js"

import "./take-photo.vue?vue&type=style&index=0&id=6ccbee48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ccbee48"]])

export default __exports__